<script>
import moment from 'moment';
import Layout from '@layouts/main.vue';
import { breakpointsMixin } from '@mixins/breakpoints-mixin.js';
import { learnComputed, learnMethods } from '@state/helpers';
const UseLargeScreen = () =>
  import(
    /* webpackChunkName: "UseLargeScreen" */ '@components/use-large-screen.vue'
  );
export default {
  page: {
    title: 'CohortList',
    meta: [
      { name: 'description', content: 'Select your cohort from the list' },
    ],
  },
  components: { Layout, UseLargeScreen },
  mixins: [breakpointsMixin],
  data() {
    return {
      heroBgImg: require('@assets/images/bg-gym-grayscale.jpeg'),
    };
  },
  computed: {
    ...learnComputed,
  },
  methods: {
    ...learnMethods,
    formatDate(date) {
      return `First Webinar ${moment(date).format('MM/DD/YYYY')}`;
    },
    isNotPastCohort(cohort) {
      return moment(cohort.start_date).isAfter();
    },
    confirmEnroll(cohort) {
      this.setSelectedCohort(cohort);
      this.$bvModal.show('confirm-enrollment-modal');
    },
  },
};
</script>

<template>
  <UseLargeScreen v-if="isSmallScreenView" />
  <Layout v-else>
    <div class="container-wrapper">
      <div
        class="hero"
        :style="{
          'background-image': `url(${heroBgImg})`,
        }"
      >
        <div class="details">
          <h3>Select a Start Date</h3>
          <p class="program-length">Each 5i5 Program is 5 weeks long</p>
          <p class="webinars">
            Webinars are held every Tuesday,
            <br />
            Office Hours every Thursday.
          </p>
        </div>
      </div>
      <div class="all-cohorts">
        <template v-for="cohort in myCohorts">
          <div
            class="cohort"
            v-if="isNotPastCohort(cohort)"
            :key="cohort._id"
            @click.stop="confirmEnroll(cohort)"
          >
            <h3>{{ cohort.label }}</h3>
            <span>{{ formatDate(cohort.start_date) }}</span>
          </div>
        </template>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" scoped>
@import '@design';
.container-wrapper {
  background: $color-cohort-main-backgraound;
  flex-direction: column;

  .hero {
    background: $color-cohort-gray;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    display: grid;
    height: 40%;
    place-items: center;
    width: 100%;

    .details {
      align-items: center;
      background: rgba($color-white-wo-rgb, 0.5);
      color: $color-black;
      display: flex;
      flex-direction: column;
      font-size: 2.1rem;
      letter-spacing: -0.3px;
      line-height: 24px;
      padding: 24px 48px;

      h3 {
        font-weight: 900;
      }
      .program-length {
        font-size: 2.1rem;
        font-weight: 100;
        margin-bottom: 3rem;
      }
      .webinars {
        margin-bottom: 0;
      }
    }
  }

  .all-cohorts {
    margin: 0 auto;
    margin-top: -30px;
    width: 60%;
    @include grid-cards(1, 35);

    .cohort {
      background: $color-white;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      font-size: 2.1rem;
      min-height: 90px;
      padding: 25px 20px;

      h3 {
        color: $color-black;
        margin-bottom: 10px;
      }
      span {
        color: $color-black;
        font-weight: 300;
      }

      &:hover {
        box-shadow: 0 0.4rem 0.8rem rgba($color-black-wo-rgb, 0.1);
        transform: scale(1.01);
      }
    }
  }
}
</style>
